// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  requestId: __t.u128().name("request_id"),
  requestedBy: __t.identity().name("requested_by"),
  valid: __t.bool(),
  modelsToCreate: __t.u32().name("models_to_create"),
  modelsToUpdate: __t.u32().name("models_to_update"),
  twinsToCreate: __t.u32().name("twins_to_create"),
  twinsToUpdate: __t.u32().name("twins_to_update"),
  twinsToSkip: __t.u32().name("twins_to_skip"),
  relationshipsToCreate: __t.u32().name("relationships_to_create"),
  relationshipsToSkip: __t.u32().name("relationships_to_skip"),
  errorCount: __t.u32().name("error_count"),
  warningCount: __t.u32().name("warning_count"),
  reportJson: __t.string().name("report_json"),
  createdAt: __t.timestamp().name("created_at"),
});
